import { Injectable } from '@angular/core';
import { LocalStorageService, UserProfileDataService } from '@project/services';
import { PreferredMediaDevices } from '../definitions';

interface MediaDevicePreferences extends PreferredMediaDevices {
  skipPreviewBeforeCall?: boolean;
}

const STORAGE_KEY_PREFIX = 'video-call-media-device-preferences';

@Injectable({
  providedIn: 'root',
})
export class MediaDevicePreferencesService {
  constructor(
    private localStorageService: LocalStorageService,
    private userProfileDataService: UserProfileDataService,
  ) {}

  public getPreferredDevices(): PreferredMediaDevices {
    const { cameraId, microphoneId, speakerId } = this.read();

    return { cameraId, microphoneId, speakerId };
  }

  public savePreferredDevices(devices: PreferredMediaDevices): void {
    this.write({ ...this.read(), ...devices });
  }

  public shouldSkipPreviewBeforeCall(): boolean {
    return this.read().skipPreviewBeforeCall === true;
  }

  public setSkipPreviewBeforeCall(skip: boolean): void {
    this.write({ ...this.read(), skipPreviewBeforeCall: skip });
  }

  private get storageKey(): string {
    return `${STORAGE_KEY_PREFIX}_${this.userProfileDataService.profile?.id ?? 'anonymous'}`;
  }

  private read(): MediaDevicePreferences {
    try {
      return JSON.parse(this.localStorageService.getItem(this.storageKey)) ?? {};
    } catch {
      return {};
    }
  }

  private write(preferences: MediaDevicePreferences): void {
    this.localStorageService.store(this.storageKey, JSON.stringify(preferences));
  }
}
